import { useStorage } from '@vueuse/core'
import { defineStore } from 'pinia'

type TLanguage = 'english' | 'spanish'
export type TLanguageAbbr = 'en' | 'es'

// interface for the language objects
interface ILanguage {
  name: string
  map: TLanguageAbbr
  label: {
    english: string
    spanish: string
  }
}
type LanguageStoreRootState = {
  language: TLanguage
  languages: [ILanguage]
}

export const useLanguageStore = defineStore({
  id: 'language',
  state: () =>
    ({
      language: useStorage('language', 'english'),
      languages: [
        {
          name: 'english',
          map: 'en',
          label: {
            english: 'English',
            spanish: 'Inglés'
          }
        },
        {
          name: 'spanish',
          map: 'es',
          label: {
            english: 'Spanish',
            spanish: 'Español'
          }
        }
      ]
    }) as unknown as LanguageStoreRootState,
  getters: {
    isValidLanguage: (state) => (language) => {
      return (
        language &&
        !!state.languages.find((l) => l.name === language.toLowerCase())
      )
    },
    currentLanguageObject: (state): ILanguage => {
      const found = state.languages.find((l) => l.name === state.language)
      if (!found) {
        throw 'no valid language set'
      } else {
        document.documentElement.setAttribute('lang', found.map)
      }
      return found
    },
    currentMapLanguage(): TLanguageAbbr {
      return this.currentLanguageObject.map
    }
  },
  actions: {
    setLanguage(value: string | null) {
      if (this.isValidLanguage(value)) {
        this.language = (value?.toLowerCase() as TLanguage) || 'english'
        document.documentElement.setAttribute('lang', this.currentMapLanguage)
        // save to local storage
        localStorage.setItem('language', this.language)
      }
    }
  }
})
